import { ThemeProvider } from "styled-components"
import { useEffect, useState } from "react"

import theme from "./theme"
import ResetStyle from "./theme/reset"
import "./theme/font.css"

import Style from "./style"
import AlertModal from "./ui/AlertModal"
import ConfirmModal from "./ui/ConfirmModal"

import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useConfirmModalAtom from "shared/model/useConfirmModalAtom"
import useThemeCookie, { BASIC } from "shared/model/useThemeCookie"
import useColorCookie from "shared/model/useColorCookie"

import Page from "page"

const App = () => {
    const [isAlertModalView] = useAlertModalAtom()
    const [isConfrimModalView] = useConfirmModalAtom()

    const [themeCookie, setThemeCookie] = useThemeCookie()
    const [colorCookie, setColorCookie] = useColorCookie()

    // 초기 실행이라 쿠키가 없다면 실행
    useEffect(() => {
        if (!themeCookie) setThemeCookie(BASIC)
        if (!colorCookie) setColorCookie({
            "type": BASIC,
            "basic": {
                "bg": "#ffffff",
                "font": "#1F2024",
            },
            "gradation": {
                "bg": "#1F2024",
                "font": "#ffffff",
                "bg1": "#4DBFFF",
                "bg2": "#E6FF4D",
                "bg3": "#4DFF89",
                "bg4": "#FF4D77",
            }
        })
    }, [])

    let newTheme = { ...theme, "color": { ...theme.color, ...colorCookie } }

    // 쿠키 변경시 styled-components theme 업데이트
    useEffect(() => {
        newTheme = { ...theme, "color": { ...theme.color, ...colorCookie } }
    }, [colorCookie])

    return (
        <ThemeProvider theme={newTheme}>
            <ResetStyle />
            <Style.ParentWrapper>
                {isAlertModalView && <AlertModal />}
                {isConfrimModalView && <ConfirmModal />}
                <Page />
            </Style.ParentWrapper>
        </ThemeProvider>
    )
}

export default App